'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgWrapper = require('../../../core/SvgWrapper.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var GeneralIcon = function GeneralIcon(props) {
  return React__default["default"].createElement(SvgWrapper, _objectSpread({}, props), React__default["default"].createElement("g", {
    id: "onboarding-/-industry-/-HOA",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, React__default["default"].createElement("polygon", {
    id: "Shape",
    points: "13.2 28 13.2 19.5294118 18.8 19.5294118 18.8 28 25.8 28 25.8 16.7058824 30 16.7058824 16 4 2 16.7058824 6.2 16.7058824 6.2 28"
  })));
};

module.exports = GeneralIcon;
